
/* MAISON ANDRÉ — Synchronisation photos et titre avec SA Variant */

document.addEventListener('click', async function (event) {
  const swatch = event.target.closest('.swatch-view-item [swatch-url]');
  if (!swatch) return;

  const card = swatch.closest('.andre-col-card');
  const productUrl = swatch.getAttribute('swatch-url');

  if (!card || !productUrl) return;

  const mainImage = card.querySelector('img:not(.andre-col-img-hover)');
  const hoverImage = card.querySelector('img.andre-col-img-hover');
  const productTitle = card.querySelector('a.andre-col-nom');

  if (!mainImage) return;

  // Empêche les anciens clics d'écraser le dernier coloris sélectionné
  const requestId = String(Date.now()) + Math.random();
  card.dataset.colorSwitchRequest = requestId;

  try {
    // Récupération des données du produit Shopify sélectionné
    const response = await fetch(productUrl + '.js');

    if (!response.ok) {
      throw new Error('Produit introuvable');
    }

    const product = await response.json();

    if (card.dataset.colorSwitchRequest !== requestId) return;

    // 1. Mise à jour de la photo principale
    if (product.images && product.images.length > 0) {
      mainImage.src = product.images[0];
      mainImage.removeAttribute('srcset');

      // 2. Mise à jour de la photo au survol
      if (hoverImage) {
        hoverImage.src = product.images[1] || product.images[0];
        hoverImage.removeAttribute('srcset');
      }
    }

    // 3. Mise à jour du véritable titre du produit
    if (productTitle && product.title) {
      productTitle.textContent = product.title;
    }

  } catch (error) {
    console.warn(
      'Maison André : changement de coloris impossible',
      error
    );
  }
}, true);
